import Loader from "react-loader-spinner";
export default function TailSpinLoader({ height = 16, width = 16, color = "whitesmoke" }) {
    return (
        <Loader type="TailSpin" color="green" width={width} height={height} style={{ display: "inline-block" }} />
    )
}